$(document).ready(function() {

    "use strict";

    window.member_categories = [];



    // Submit Form to data
    $('#joinPaidForm').submit(function(e) {
        e.preventDefault();

        var self = $(this);

        // Check Member Categories
        if( window.member_categories.length == 0 ) {
            $('.sub_cat_box').addClass('has-error');
        }

        if( self.valid() && window.member_categories.length > 0 ) {

            var dataObject = window.helper.formToObject(self);
            $('button[name="__joinBtn"]').prop('disabled', true).addClass('spinr');

            $.ajax({
                url: self.attr('action'),
                type: 'POST',
                data: dataObject,
                dataType: 'json',
                success: function(response, textStatus, xhr) {
                    if(xhr.status === 200) {

                        document.location.href = response._redirect;
                    }
                },
                complete: function(xhr, textStatus) {
                    window.loader.stop();
                    if( xhr.status !== 200 ) {
                        $('button[name="__joinBtn"]').prop('disabled', false).removeClass('spinr');
                        var response = xhr.responseJSON,
                            msg = "";

                        if( ! response.hasOwnProperty("message") ) {
                            for( var i in response ) {
                                msg += response[i] + "<br>";
                            }
                        }
                        else msg = response.message;

                        window.notify.push( msg );
                        //alert(response.message);
                    }
                }
            });
        }
    });



    // Set Default Path
    // for membership confirmation
    window.confirmPath = window.location.origin + window.location.pathname;




    // Select Place on Membership Confirmation
    // ----------------------------------------
    $('.__pricing_box').click(function(e) {
        e.preventDefault();

        var plan = $(this).data('plan'),
            host = window.location.origin,
            path = window.location.pathname,
            user = path.split('/')[1],
            url = host+'/'+user+'/'+(plan.toLowerCase())+'/confirm';

        $('.__pricing_box .bg-white').removeClass('active');
        $('.bg-white', this).addClass('active');

        $('.__selected_plan').text(plan);
        window.confirmPath = url;

        if( window.history ) {
            var stateObj = {plan: "plan" };
            history.pushState(stateObj, (plan.toLowerCase()), url);
        }
        else {
            document.location.href = url;
        }
    });



    // Redirect After Plan Confirm
    // -----------------------------
    $('.__plan_confirm').click(function(e) {
        e.preventDefault();

        var replaceWith = window.confirmPath.split('/').pop(),
            regex = new RegExp(replaceWith, 'i'),
            redirectUrl = window.confirmPath.replace(regex, 'payment');

        document.location.href = redirectUrl;
    });





    // Select Payment Method
    // ---------------------------
    $('div.radio').click(function(e) {
        e.preventDefault();

        var paymentMethod = $('input[type="radio"]', this),
            method = paymentMethod.val();

        // Hide show checkout with
        var cardOptions = ['credit_card', 'wallet', 'upi', 'internet_banking'];
        if( cardOptions.indexOf(method) >= 0 ) {

            $('._online_payment_methods i').text('radio_button_unchecked');
            $('._online_payment_methods input[name="online_pay_option"]').prop('checked', false);

            var _class = '_payumoney';
            if( window.pg != "undefined" ) {
                _class = window.pg == 'pu' ? '_payumoney' : ( window.pg == 'rp' ? '_razor_pay' : '_cc_pay' );
            }

            $('i', '.'+_class).text('radio_button_checked');
            $('input[name="online_pay_option"]', '.'+_class).prop('checked', true);

            if( method == 'upi' ) {
                $('i', '._razor_pay').text('radio_button_checked');
                $('input[name="online_pay_option"]', '._razor_pay').prop('checked', true);

                $('._payumoney').hide();
                $('._cc_pay').hide();
            }
            else if( method == 'wallet' ) {

                if( window.pg != "undefined" && window.pg == "cc" ) {
                    _class = "_payumoney";
                }

                $('i', '.'+_class).text('radio_button_checked');
                $('input[name="online_pay_option"]', '.'+_class).prop('checked', true);

                $('._payumoney').show();
                $('._cc_pay').hide();
            }
            else {
                $('._payumoney').show();
                $('._cc_pay').show();
            }

            $('._online_payment_methods').show();
        }
        else $('._online_payment_methods').hide();


        $('div.radio input[type="radio"]').prop('checked', false);
        $('div.radio').removeClass('active');
        $('._bg_img, .summary .other').hide();

        $(this).addClass('active');
        paymentMethod.prop('checked', true);
        $('.summary .'+method).show();
    });




    // Wallet, Credit and Debit Card Payment
    // ----------------------------------------
    $('._op_mode').click(function(e) {
        e.preventDefault();

        var paymentMode = $('input[name="online_pay_option"]', this).val();
        
        if( paymentMode == 'paypal' ) {
            $('.usd, .usd_show').show();
            $('.inr, .inr_show').hide();
        }
        else {
            $('.usd, .usd_show').hide();
            $('.inr, .inr_show').show();
        }

        $('._online_payment_methods i').text('radio_button_unchecked');
        $('._online_payment_methods input[name="online_pay_option"]').removeAttr('checked');

        $('i', this).text('radio_button_checked');
        $('input[name="online_pay_option"]', this).prop('checked', true);
    });




    // Handle Discount Coupon
    // ----------------------------
    $('button[name="redeem_coupon"]').click(function(e) {
        e.preventDefault();

        var coupon = $.trim($('input[name="promo_code"]').val()),
            self = $(this);

        if( coupon.length > 0 && coupon != "" ) {

            self.prop('disabled', true);
            $('button[name="info_pay_now"]').prop('disabled', true).addClass('spinr');

            $.ajax({
                url: window.location.origin + '/redeem_coupon',
                type: 'POST',
                data: {'_token': $('input[name="_token"]').val(), 'source': window.location.pathname, 'coupon': coupon},
                success: function(response, textStatus, xhr) {
                    if(xhr.status === 200) {
                        var discount = response.discount,
                            planAmount = window.plan.amount,
                            serviceTax = window.plan.service_tax,
                            discountedAmount = 0, subTotal = 0, serviceTaxAmt = 0,
                            kkc = 0, sbc = 0, finalAmount = 0;

                        discountedAmount = Math.round(planAmount * discount / 100);
                        subTotal = planAmount - discountedAmount;

                        serviceTaxAmt = Math.round(subTotal * parseFloat(serviceTax.service_tax) / 100);
                        kkc = Math.round(subTotal * parseFloat(serviceTax.service_tax_kkc) / 100);
                        sbc = Math.round(subTotal * parseFloat(serviceTax.service_tax_sbc) / 100);
                        finalAmount = subTotal + serviceTaxAmt + kkc + sbc;

                        $('._discount').text('-'+discountedAmount);
                        $('._service_tax').text(serviceTaxAmt);
                        $('._service_tax_kkc').text(kkc);
                        $('._service_tax_sbc').text(sbc);
                        $('.final_amount').text(finalAmount);
                    }
                },
                complete: function(xhr, textStatus) {
                    self.prop('disabled', false);
                    $('button[name="info_pay_now"]').prop('disabled', false).removeClass('spinr');
                    if( xhr.status !== 200 ) {

                        var response = xhr.responseJSON;

                        window.notify.push( response.message );

                        var planAmount = window.plan.amount,
                            serviceTax = window.plan.service_tax,
                            serviceTaxAmt = 0, kkc = 0, sbc = 0, finalAmount = 0;

                        serviceTaxAmt = Math.round(planAmount * parseFloat(serviceTax.service_tax) / 100);
                        kkc = Math.round(planAmount * parseFloat(serviceTax.service_tax_kkc) / 100);
                        sbc = Math.round(planAmount * parseFloat(serviceTax.service_tax_sbc) / 100);
                        finalAmount = planAmount + serviceTaxAmt + kkc + sbc;

                        $('._discount').text('N/A');
                        $('._service_tax').text(serviceTaxAmt);
                        $('._service_tax_kkc').text(kkc);
                        $('._service_tax_sbc').text(sbc);
                        $('.final_amount').text(finalAmount);
                    }
                }
            });
        }
    });

});
